import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { SafeAreaView } from '@react-navigation/native';
import TouchableItem from './TouchableItem';
/**
 * Component that renders the navigation list in the drawer.
 */

var DrawerNavigatorItems = function DrawerNavigatorItems(_ref) {
  var items = _ref.items,
      activeItemKey = _ref.activeItemKey,
      activeTintColor = _ref.activeTintColor,
      activeBackgroundColor = _ref.activeBackgroundColor,
      inactiveTintColor = _ref.inactiveTintColor,
      inactiveBackgroundColor = _ref.inactiveBackgroundColor,
      getLabel = _ref.getLabel,
      renderIcon = _ref.renderIcon,
      onItemPress = _ref.onItemPress,
      itemsContainerStyle = _ref.itemsContainerStyle,
      itemStyle = _ref.itemStyle,
      labelStyle = _ref.labelStyle,
      activeLabelStyle = _ref.activeLabelStyle,
      inactiveLabelStyle = _ref.inactiveLabelStyle,
      iconContainerStyle = _ref.iconContainerStyle,
      drawerPosition = _ref.drawerPosition;
  return React.createElement(View, {
    style: [styles.container, itemsContainerStyle]
  }, items.map(function (route, index) {
    var _ref2;

    var focused = activeItemKey === route.key;
    var color = focused ? activeTintColor : inactiveTintColor;
    var backgroundColor = focused ? activeBackgroundColor : inactiveBackgroundColor;
    var scene = {
      route: route,
      index: index,
      focused: focused,
      tintColor: color
    };
    var icon = renderIcon(scene);
    var label = getLabel(scene);
    var accessibilityLabel = typeof label === 'string' ? label : undefined;
    var extraLabelStyle = focused ? activeLabelStyle : inactiveLabelStyle;
    return React.createElement(TouchableItem, {
      key: route.key,
      accessible: true,
      accessibilityLabel: accessibilityLabel,
      onPress: function onPress() {
        onItemPress({
          route: route,
          focused: focused
        });
      },
      delayPressIn: 0
    }, React.createElement(SafeAreaView, {
      style: [{
        backgroundColor: backgroundColor
      }, styles.item, itemStyle],
      forceInset: (_ref2 = {}, _defineProperty(_ref2, drawerPosition, 'always'), _defineProperty(_ref2, drawerPosition === 'left' ? 'right' : 'left', 'never'), _defineProperty(_ref2, "vertical", 'never'), _ref2)
    }, icon ? React.createElement(View, {
      style: [styles.icon, focused ? null : styles.inactiveIcon, iconContainerStyle]
    }, icon) : null, typeof label === 'string' ? React.createElement(Text, {
      style: [styles.label, {
        color: color
      }, labelStyle, extraLabelStyle]
    }, label) : label));
  }));
};
/* Material design specs - https://material.io/guidelines/patterns/navigation-drawer.html#navigation-drawer-specs */


DrawerNavigatorItems.defaultProps = {
  activeTintColor: '#2196f3',
  activeBackgroundColor: 'rgba(0, 0, 0, .04)',
  inactiveTintColor: 'rgba(0, 0, 0, .87)',
  inactiveBackgroundColor: 'transparent'
};
var styles = StyleSheet.create({
  container: {
    paddingVertical: 4
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  icon: {
    marginHorizontal: 16,
    width: 24,
    alignItems: 'center'
  },
  inactiveIcon: {
    /*
     * Icons have 0.54 opacity according to guidelines
     * 100/87 * 54 ~= 62
     */
    opacity: 0.62
  },
  label: {
    margin: 16,
    fontWeight: 'bold'
  }
});
export default DrawerNavigatorItems;